<div class="instance-details">
  <app-page-loader *ngIf="isLoading"></app-page-loader>
</div>

<div class="max-width-lg bg-gradient overlap-instance">
  <app-breadcrumb class="mt-16" [items]="breadcrumbItems"></app-breadcrumb>
  <div class="flex flex-row justify-between">
    <div class="flex flex-row flex-auto mb-24">
      <div class="flex flex-col mr-32">
        <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-24" [ngClass]="{'disabled': (!service?.id || !blueprint?.id)}"
          [routerLink]="['/', tenant, RouterSegments.SERVICES, service?.id,
          RouterSegments.BLUEPRINTS, blueprint?.id]"></mat-icon>
      </div>
      <div class="flex flex-col flex-auto justify-between">
        <div class="flex-col">
          <div class="flex flex-col justify-between">
            <div class="mat-headline-3 mb-0">{{ instance?.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="max-width-lg pb-130">
  <div class="flex flex-row mt-24">
    <div class="left-panel overlap-instance">
      <div class="vertical-menu">
        <div class="flex flex-row menu-item" [ngClass]="isOverview ?  'selected' : 'null'"
          (click)="gotoSection(InstanceTabs.OVERVIEW)">
          <mat-icon svgIcon="language" class="icon-md-1 mr-12"></mat-icon>
          {{ 'INSTANCE_DETAILS.OVERVIEW' | transloco }}
        </div>
        <div class="flex flex-row menu-item" [ngClass]="isMonitoring ?  'selected' : 'null'"
          (click)="gotoSection(InstanceTabs.MONITORING)">
          <mat-icon svgIcon="donut_large" class="icon-md mr-12"></mat-icon>
          {{ 'INSTANCE_DETAILS.MONITORING' | transloco }}
        </div>
        <div class="flex flex-row menu-item" [ngClass]="isEndpoints ?  'selected' : 'null'"
          (click)="gotoSection(InstanceTabs.VIEW_ENDPOINTS)">
          <mat-icon svgIcon="desktop_windows" class="icon-md mr-12"></mat-icon>
          {{ 'INSTANCE_DETAILS.VIEW_ENDPOINTS' | transloco }}
        </div>
        @if (!isExternalClient) {
          <div class="flex flex-row menu-item items-center" [ngClass]="isReleasePack ?  'selected' : 'null'"
            (click)="gotoSection(InstanceTabs.RELEASE_PACKAGE)">
            <img class="storage-icon mr-8" [ngClass]="{'unselected-icon': !isReleasePack}"
              src="/assets/images/home_storage.svg" />
            <span>{{ 'INSTANCE_DETAILS.RELEASE_PACKAGE' | transloco }}</span>
          </div>
        }
      <!-- <div *ngIf="instance?.deploymentClass === DeploymentClass.D || instance?.deploymentClass === DeploymentClass.C || instance?.deploymentClass === DeploymentClass.B" class="flex flex-row menu-item" [ngClass]="isRvtPack ?  'selected' : 'null'"
          (click)="gotoSection(InstanceTabs.RVT_PACKAGE)">
          <mat-icon svgIcon="inventory_2" class="icon-md mr-12"></mat-icon>
          {{ 'INSTANCE_DETAILS.RUN_TEST' | transloco }}
        </div>--> 
      </div>
    </div>
    <div class="right-panel flex-auto pl-30 instance-details-tabs">
      <ng-container *ngIf="isOverview">
        <div class="mat-headline fw-700 fs-28 mb-24">{{ 'INSTANCE_DETAILS.OVERVIEW' | transloco }}</div>
        <mat-divider class="neutral-blue-6"></mat-divider>
        <div class="flex flex-row grid-flow-col">
          <div class="left-pane flex flex-col">
            <div class="label-text flex mt-24">
              <div class="key">{{ 'INSTANCE_DETAILS.SERVICE_DEFINITION_NAME' | transloco }}</div>
              <div>:&nbsp;</div>
              <div *ngIf="blueprint?.name; else loader" class="val fw-600">{{blueprint?.name}}</div>
            </div>
            <ng-template #loader>
              <div class="pl-6 skeleton-loader">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
          </div>
          @if (!isExternalClient) {
            <div class="right-pane flex flex-col">
              <div class="label-text flex mt-24">
                <div class="key">{{ 'INSTANCE_DETAILS.SOLUTION' | transloco }}</div>
                <div>:&nbsp;</div>
                <div *ngIf="service?.name; else loader" class="val fw-600 w-300px">{{service?.name}}</div>
              </div>
              <ng-template #loader>
                <div class="pl-6 skeleton-loader">
                  <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                </div>
              </ng-template>
            </div>
          }
          @if (isExternalClient) {
            <div class="right-pane flex flex-col">
              <div class="label-text flex mt-24">
                <div class="key">{{ 'INSTANCE_DETAILS.AVAILABILITY_STATE' | transloco }}</div>
                <div>:&nbsp;</div>
                <div *ngIf="instance?.availabilityState; else loader" class="val fw-600 flex items-center justify-center availableState" [ngClass]="instance?.availabilityState.toLowerCase()">
                  <mat-icon [svgIcon]="availableStateIcons[instance?.availabilityState.toLowerCase()]" class="icon-sm"></mat-icon>
                  {{ instance?.availabilityState ? (instance?.availabilityState === 'not_ready' ? 'Not Ready' : (instance?.availabilityState | titlecase)) : '-' }}
                </div>
              </div>
              <ng-template #loader>
                <div class="pl-6 skeleton-loader">
                  <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                </div>
              </ng-template>
            </div>
          }
        </div>
        @if (!isExternalClient) {
          <div class="flex flex-row grid-flow-col">
            <div class="left-pane flex flex-col">
              <div class="label-text flex mt-24">
                <div class="key">{{ 'BLUEPRINT_SUMMARY.RELEASE' | transloco }}</div>
                <div>:&nbsp;</div>
                <div class="val fw-600">{{(releaseVersion ? releaseVersion : 'N/A')}}</div>
                <div *ngIf="isAMR" class="flex flex-row justify-center items-center amr-text ml-10 mt-1 pl-10 fw-600">
                  {{('BLUEPRINT_SUMMARY.AMR' | transloco)}}
                  </div>
              </div>
              <ng-template #loader>
                <div class="pl-6 skeleton-loader">
                  <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                </div>
              </ng-template>
            </div>
            <div class="left-pane flex flex-col">
              <div class="label-text flex mt-24">
                <div class="key">{{ 'INSTANCE_DETAILS.STATUS' | transloco }}</div>:&nbsp;
                <div *ngIf="instance?.status; else loader" class="val fw-600">{{instance?.status | titlecase}}</div>
              </div>
              <ng-template #loader>
                <div class="pl-6 skeleton-loader">
                  <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                </div>
              </ng-template>
            </div>
            <!-- <div class="right-pane flex flex-col">
              <div class="label-text flex mt-24">
                <div class="key">{{ 'INSTANCE_DETAILS.REGION' | transloco }}</div>
                <div>:&nbsp;</div>
                <div *ngIf="instance?.region; else loader" class="val fw-600">{{instance?.region}}</div>
              </div>
              <ng-template #loader>
                <div class="pl-6 skeleton-loader">
                  <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                </div>
              </ng-template>
            </div> -->
          </div>
        }

        <div class="flex flex-row grid-flow-col">
          <div class="left-pane flex flex-col">
            <div class="label-text flex mt-24">
              <div class="key">{{ 'INSTANCE_DETAILS.CREATED_DATE' | transloco }}</div>:&nbsp;
              <div *ngIf="instance; else loader" class="val fw-600">{{instance?.dateCreated ? (instance?.dateCreated | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}}</div>
            </div>
            <ng-template #loader>
              <div class="pl-6 skeleton-loader">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
          </div>
          <div class="right-pane flex flex-col">
            <div class="label-text flex mt-24">
              <div class="key">{{ 'INSTANCE_DETAILS.UPDATED_DATE' | transloco }}</div>:&nbsp;
              <div *ngIf="instance; else loader" class="val fw-600">{{instance?.dateUpdated ? (instance?.dateUpdated | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}}</div>
            </div>
            <ng-template #loader>
              <div class="pl-6 skeleton-loader">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
          </div>
          <!-- <div class="right-pane flex flex-col">
            <div class="label-text flex mt-24 flex flex-row">
              <div class="key">{{ 'INSTANCE_DETAILS.RELEASE_NOTES' | transloco }}</div>:&nbsp;
              <div class="val fw-600 flex flex-row view-release-notes">
                <ng-container *ngIf="serviceVersions && serviceVersions[0]; else loader">
                  <mat-icon svgIcon="open_in_new" class="icon-md mr-10 cursor-pointer" (click)="navigateToUrl(serviceVersions[0]?.releaseNotes)"></mat-icon>
                  <a class="view-release-internal-link mat-body cursor-pointer fw-600" [href]="serviceVersions[0]?.releaseNotes" target="_blank">{{'BLUEPRINT_SUMMARY.VIEW_RELEASE_NOTES' | transloco}}</a>
                  <mat-icon *ngIf="'BLUEPRINT_SUMMARY.VIEW_RELEASE_NOTES'" (click)="onCopyId(serviceVersions[0]?.releaseNotes)"  [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" class="copy-icon icon-md ml-10 cursor-pointer"></mat-icon>
                </ng-container>
              </div>
            </div>
            <ng-template #loader>
              <div class="pl-6 skeleton-loader">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
          </div> -->
        </div>

        <div class="flex flex-row grid-flow-col">
          <div class="left-pane flex flex-col">
            <div class="label-text flex mt-24">
              <div class="key">{{ 'INSTANCE_DETAILS.CLASS' | transloco }}</div>:&nbsp;
              <div *ngIf="instance?.deploymentClass; else loader" class="val fw-600">{{instance?.deploymentClass}}</div>
            </div>
            <ng-template #loader>
              <div class="pl-6 skeleton-loader">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
          </div>
          <div class="right-pane flex flex-col">
            <div class="label-text flex mt-24">
              <div class="key">{{ 'INSTANCE_DETAILS.ENVIRONMENT' | transloco }}</div>:&nbsp;
              <div *ngIf="instance; else loader" class="val fw-600">{{instance?.environment ? instance?.environment : 'N/A' }}</div>
            </div>
            <ng-template #loader>
              <div class="pl-6 skeleton-loader">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- <div class="flex flex-row grid-flow-col">
          <div class="left-pane flex flex-col">
            <div class="label-text flex mt-24">
              <div class="key">{{ 'INSTANCE_DETAILS.STATUS' | transloco }}</div>:&nbsp;
              <div *ngIf="instance?.status; else loader" class="val fw-600">{{instance?.status | titlecase}}</div>
            </div>
            <ng-template #loader>
              <div class="pl-6 skeleton-loader">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
          </div>
          <div class="right-pane flex flex-col">
            <div class="label-text flex mt-24">
              <div class="key">{{ 'INSTANCE_DETAILS.UPDATED_DATE' | transloco }}</div>:&nbsp;
              <div *ngIf="instance?.dateUpdated; else loader" class="val fw-600">{{instance?.dateUpdated | date: 'dd MMM yyyy, HH:mm' + ' UTC'}}</div>
            </div>
            <ng-template #loader>
              <div class="pl-6 skeleton-loader">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
          </div>
        </div> -->

      </ng-container>
      @if (isMonitoring) {
        <div class="flex flex-row justify-between">
          <div class="mat-headline fw-700 fs-28 mb-24">{{ 'INSTANCE_DETAILS.MONITORING' | transloco }}</div>
          <button class="btn-link mat-headline-6 fw-700 flex justify-center items-center"
                  (click)="refreshMonitoring();">
            <mat-icon svgIcon="refresh" class="mr-12" [@rotate]="count"
                      (@rotate.done)="loading && count=count+1"></mat-icon>
            {{'BLUEPRINT_SUMMARY.REFRESH_INSTANCE' | transloco}}
          </button>
        </div>
        <mat-divider class="neutral-blue-6"></mat-divider>
        <div class="health-card mt-16" *ngIf="!noMonitoringData && nonProdZone as zone">
          <div class="donut-section">
            <div class="donut" [ngStyle]="zone.donutStyle" [@donutAnimation]="donutAnimationState">
              <div class="donut-center">
                <div class="fs-32 fw-500 font-color">{{ zone.services }}</div>
                <div class="fs-20 fw-400 font-color">{{ 'INSTANCE_DETAILS.SERVICES' | transloco }}</div>
              </div>
            </div>
          </div>
          <div class="content-section">
            <div class="status-row pl-24">
              <div class="status healthy" [class.active]="activeStatus === 'HEALTHY'" (click)="onStatusChange('HEALTHY')">
                {{ 'INSTANCE_DETAILS.HEALTHY' | transloco }} 
                <span class="badge">{{ zone.healthy }}</span>
              </div>
              <div class="status impacted" [class.active]="activeStatus === 'IMPACTED'" (click)="onStatusChange('IMPACTED')">
                {{ 'INSTANCE_DETAILS.IMPACTED' | transloco }} 
                <span class="badge">{{ zone.impacted }}</span>
              </div>
              <div class="status critical" [class.active]="activeStatus === 'CRITICAL'" (click)="onStatusChange('CRITICAL')">
                {{ 'INSTANCE_DETAILS.CRITICAL' | transloco }} 
                <span class="badge">{{ zone.critical }}</span>
              </div>
            </div>
            <div class="inner-panel mb-12">
              <div class="left-panel-rag flex flex-col">
                <div class="app-tag" *ngFor="let item of getFilteredItems(zone)" [class.active]="selectedItem === item" (click)="selectItem(item)">
                  {{ item.product }}
                </div>
                <div class="empty p-12" *ngIf="getFilteredItems(zone).length === 0">No services</div>
              </div>
              <div class="flex flex-col ml-12 width-right">
                <div *ngIf="selectedItem?.summary" class="system-status" [ngClass]="ragToStatus(selectedItem.rag).toLowerCase()">
                  {{ selectedItem.summary }}
                </div>
                <!-- <div class="right-panel-rag">
                  <div class="coverage">
                    <div class="title fw-700 fs-14">{{ 'INSTANCE_DETAILS.LIST_OF_COVERAGE' | transloco }}</div>
                    <div *ngFor="let row of filteredMonitoringTable" class="flex flex-row w-100-percent mb-12">
                      <div class="justify-start monitoring-type ml-12 mr-12 p-12 width-40">
                        {{ row.monitoringType }}
                      </div>
                      <div class="justify-start entity p-12 mr-12 width-60">
                        <span *ngFor="let entity of row.monitoringEntity">
                        {{ entity }}<br />
                        </span>
                      </div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="noMonitoringData || !nonProdZone" class="flex flex-col items-center mb-20 pt-64 pb-64">
          <mat-icon svgIcon="inventory_2" class="no-release-color icon-lg mr-12"></mat-icon>
          <div class="mat-subtitle-1 fw-700 mt-12 mb-16 fs-20">{{'INSTANCE_DETAILS.NO_SERVICE_AVAILABLE' | transloco}}</div>
        </div>
      }
      <ng-container *ngIf="isEndpoints && instance?.endpoints?.length > 0">
        <div class="mat-headline fw-700 fs-28 mb-24">{{ 'INSTANCE_DETAILS.VIEW_ENDPOINTS' | transloco }}</div>
        <mat-divider class="neutral-blue-6"></mat-divider>
        <div class="endpoints-container mt-20 p-8">
          <ng-container *ngFor="let endpoint of instance?.endpoints">
            <div class="flex flex-col row-content">
                <div class="flex items-center p-16">
                  <div class="flex name-section">
                    <div class="flex items-center endpoint-name p-6">
                      <mat-icon svgIcon="open_in_new" class="icon-md mr-10 cursor-pointer" (click)="navigateToUrl(endpoint?.url)"></mat-icon>
                      <a class="mat-body cursor-pointer fw-600" [href]="endpoint?.url" target="_blank">{{endpoint?.name}}</a>
                      <mat-icon *ngIf="endpoint?.name" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" class="copy-icon icon-sm cursor-pointer ml-10" (click)="onCopyId(endpoint?.url)"></mat-icon>
                    </div>
                  </div>
                  <div class="description" [title]="endpoint?.description">
                    {{endpoint?.description ? endpoint?.description : ('BLUEPRINT_SUMMARY.NA' | transloco)}}
                  </div>
                </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="isEndpoints && istanceLoaded && (!instance?.endpoints || instance?.endpoints?.length === 0)">
        <div class="flex flex-col items-center mb-20 pt-64 pb-64 endpoints-container">
          <mat-icon svgIcon="desktop_access_disabled" class="no-release-color icon-lg mr-12"></mat-icon>
          <div class="mat-subtitle-1 fw-700 mt-24 mb-16 fs-28">{{'INSTANCE_DETAILS.ENDPOINTS_NOT_AVAILABLE' | transloco}}</div>
          <div class="mat-body-1 not-available-subtext fs-20 fw-500 pb-24">{{'INSTANCE_DETAILS.WE_ARE_WORKING_TEXT' | transloco}}</div>
          <div class="flex flex-row justify-center items-center mb-20">
            <button class="accent" type="button" (click)="onSupportClick()"> {{ 'BLUEPRINT_SUMMARY.ERROR.REPORT' | transloco }} </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isReleasePack">
        <div class="relative">
          <div class="flex justify-end mt-16 position">
          <button class="btn-link mat-headline-6 fw-700 flex justify-center items-center"
                  (click)="refreshInstanceForm();">
            <mat-icon svgIcon="refresh" class="mr-12" [@rotate]="count"
                      (@rotate.done)="loading && count=count+1"></mat-icon>
            {{'BLUEPRINT_SUMMARY.REFRESH_INSTANCE' | transloco}}
          </button>
        </div>
        <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="tabChange($event)" animationDuration="0ms">
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="section-label mat-headline-6">{{'INSTANCE_DETAILS.APPLY_RELEASE_PACKAGE' | transloco }}</span>
            </ng-template>
            <mat-divider class="neutral-2"></mat-divider>
            <ng-container *ngIf="availableConfigurations?.length > 0 && configurationLoaded; else notAvailable">
              <app-instance-apply-configuration  [applyConfigInProgressing]="applyConfigInProgress" [availableConfigurations]="availableConfigurations"
              (applyConfigClick)="applyConfigClick($event)" [isExternalClient]="isExternalClient" [instance]="instance" [isVerifying]="isVerifying" [configs]="configurations"></app-instance-apply-configuration>
            </ng-container>
            <ng-container *ngIf="!configurationLoaded">
              <div class="pt-76">
                <div class="pt-12 pb-12 pl-20 mb-8 header-loader">
                  <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                  <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                  <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                </div>
                <ng-container *ngFor="let item of [1,2,3]">
                  <div class="p-20 pt-24 mb-8 loader">
                    <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #notAvailable>
              <div *ngIf="configurationLoaded" class="flex flex-col items-center mb-20 pt-64 pb-64">
                <mat-icon svgIcon="inventory_2" class="no-release-color icon-lg mr-12"></mat-icon>
                <div class="mat-subtitle-1 fw-700 mt-12 mb-16 fs-20">{{'INSTANCE_DETAILS.NO_RELEASE_PACKAGE' | transloco}}</div>
              </div>
            </ng-template>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="section-label mat-headline-6">{{'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</span>
            </ng-template>
            <mat-divider class="neutral-2"></mat-divider>
            <div class="flex flex-row justify-between items-center mb-24 mt-16 w-100-percent">
              <div class="mat-body-1 fw-700 title m-0">
                <span class="mr-8 mat-headline-6 fw-700 fs-16">{{ 'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</span>
              </div>
              @if(!isExternalClient) {
              <div class="flex flex-row items-center">
                <button [matMenuTriggerFor]="menu" #filterTrigger class="flex justify-between items-center fw-500 white-bg mr-20">
                  <mat-icon svgIcon="filter_alt" class="mr-8 mb-2"></mat-icon>
                  <span class="">{{ 'INSTANCE_DETAILS.FILTERS' | transloco }}</span>
                </button>
                <mat-menu #menu="matMenu" class="justify-between items-center pl-24 pr-24 pt-16 pb-16">
                  <span class="mat-subtitle-2 fs-14">{{ 'INSTANCE_DETAILS.FILTER_BY_STATUS' | transloco }}</span>
                  <mat-divider class="neutral-2 mt-8 mb-16"></mat-divider>
                  <div class="flex flex-col overflow-class pr-10 filter-menu">
                    <div *ngFor="let option of filterOptions" class="flex flex-row items-center cursor-pointer w-100-percent p-6"
                      (click)="!isExternalClient ? filterOptionChange(option): ''">
                      <mat-icon *ngIf="selectedFilter.value !== option.value" svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
                      <mat-icon *ngIf="selectedFilter.value === option.value" svgIcon="radio_button_checked" class="radio-icon cursor-pointer">
                        </mat-icon>
                      <span class="mat-body-1 fw-500 ml-6 mr-auto mb-0 primary-fg">
                        {{option.label}}
                      </span>
                    </div>
                  </div>
                </mat-menu>
                <app-search-filter placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
              </div>
              }
            </div>
            <ng-container *ngIf="pageConfigurationStates?.length > 0 && configResultsLoaded; else resultNotAvailable">
              <div class="tbl tbl-configurations-state w-100-percent pb-12">
                <div class="tbl-header-row primary mb-8 user-select-none fs-14">
                  <div class="tbl-cell col-release-package-name pl-12">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.RELEASE_PACKAGE_NAME' | transloco }}</div>
                  <div class="tbl-cell col-version">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.VERSION' | transloco }}</div>
                  <div class="tbl-cell col-start-time cursor-pointer" (click)="doSort('applicationStartTime')">
                    {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco }}
                    <ng-container [ngTemplateOutlet]="sortIcon"
                      [ngTemplateOutletContext]="{sort: sort, property: 'applicationStartTime'}"></ng-container>
                  </div>
                  <div class="tbl-cell col-end-time cursor-pointer" (click)="doSort('applicationFinishTime')">
                    {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}
                    <ng-container [ngTemplateOutlet]="sortIcon"
                      [ngTemplateOutletContext]="{sort: sort, property: 'applicationFinishTime'}"></ng-container>
                  </div>
                  <div class="tbl-cell col-duration cursor-pointer" (click)="doSort('duration')">
                    {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}
                    <ng-container [ngTemplateOutlet]="sortIcon"
                      [ngTemplateOutletContext]="{sort: sort, property: 'duration'}"></ng-container>
                  </div>
                  <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
                </div>
                <div class="tbl-body">
                  <div *ngFor="let configurationState of pageConfigurationStates" class="tbl-border mb-8">
                    <div class="tbl-body-row tbl-high-row">
                      <div class="tbl-cell col-release-package-name cursor-pointer pl-12" (click)="!isExternalClient ? configurationNameClick(configurationState): ''">
                        <span class="underline fw-500">{{ configurationsMap[configurationState.configurationId].manifest.name }}</span>
                        <div *ngIf="configurationState?.codeResult" class="code-package ml-16" ><mat-icon svgIcon="integration_instructions" [matTooltip]="'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.CODE_PACKAGE_AVAILABLE' | transloco | titlecase"
                          matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16" class="icon-md-1"></mat-icon></div>
                        <button *ngIf="configurationState?.hotfix === true" class="flex flex-row jutsify-center items-center hotfix mt-4 ml-16 h-16 w-55 fw-700 fs-10 cursor-default">{{'BUTTONS.HOTFIX' | transloco}}</button>
                      </div>
                      <div class="tbl-cell col-version fw-500">
                        {{ configurationsMap[configurationState.configurationId].manifest.version }}
                      </div>
                      <div class="tbl-cell col-start-time fw-500">
                        {{ configurationState.applicationStartTime | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET }}
                      </div>
                      <div class="tbl-cell col-end-time fw-500">
                        {{ configurationState?.applicationFinishTime? (configurationState?.applicationFinishTime | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) : '-' }}
                      </div>
                      <div class="tbl-cell col-duration fw-500">
                        {{ configurationState.applicationStartTime | duration : configurationState.applicationFinishTime : '-' }}
                      </div>
                      <div class="tbl-cell col-status">
                        <div class="status-tag" [ngClass]="[configurationState.status === ConfigurationApplicationStatus.SUCCESS ? 'success' : configurationState.status === ConfigurationApplicationStatus.VERIFIED ? 'verified' : 'fail']">
                          <ng-container [ngSwitch]="configurationState.status">
                            <span *ngSwitchCase="ConfigurationApplicationStatus.SUCCESS">{{ 'CONFIGURATIONS.VIEW_RESULTS.SUCCESS' | transloco }}</span>
                            <span *ngSwitchCase="ConfigurationApplicationStatus.VERIFIED">{{ 'CONFIGURATIONS.VIEW_RESULTS.VERIFIED' | transloco }}</span>
                            <span *ngSwitchDefault>{{ 'CONFIGURATIONS.VIEW_RESULTS.FAILED' | transloco }}</span>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!configResultsLoaded">
              <div class="pt-8">
                <div class="pt-12 pb-12 pl-20 mb-8 header-loader">
                  <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                  <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                  <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                </div>
                <ng-container *ngFor="let item of [1,2,3]">
                  <div class="p-20 pt-24 mb-8 loader">
                    <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #resultNotAvailable>
              <div *ngIf="configResultsLoaded" class="flex flex-col items-center mb-20 pt-64 pb-64">
                <mat-icon svgIcon="inventory_2" class="no-release-color icon-lg mr-12"></mat-icon>
                <div class="mat-subtitle-1 fw-700 mt-12 mb-16 fs-20">{{'INSTANCE_DETAILS.NO_RESULT_AVAILABLE' | transloco}}</div>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
        </div>
      </ng-container>
      <ng-container *ngIf="isRvtPack && (instance?.deploymentClass === DeploymentClass.D || instance?.deploymentClass === DeploymentClass.C || instance?.deploymentClass === DeploymentClass.B)">
        <mat-tab-group [selectedIndex]="selectedRvtTab" (selectedIndexChange)="rvtTabChange($event)" animationDuration="0ms">
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="section-label mat-headline-6">{{'INSTANCE_DETAILS.RVT_PACKAGE' | transloco }}</span>
            </ng-template>
            <mat-divider class="neutral-2"></mat-divider>
            <ng-container *ngIf="configurationsForRvt?.length > 0 && configurationLoaded; else notAvailable">
              <app-instance-execute-rvt [executeRvtInProgressing]="executeRvtInProgress" [availableConfigurationsForRvt]="configurationsForRvt"
              (executeRvtClick)="!isExternalClient ? executeRvtClick($event) : ''"  [instance]="instance" [configs]="configurations"></app-instance-execute-rvt>
            </ng-container>
            <ng-container *ngIf="!configurationLoaded">
              <div class="pt-76">
                <div class="pt-12 pb-12 pl-20 mb-8 header-loader">
                  <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                  <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                  <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                </div>
                <ng-container *ngFor="let item of [1,2,3]">
                  <div class="p-20 pt-24 mb-8 loader">
                    <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #notAvailable>
              <div *ngIf="configurationLoaded" class="flex flex-col items-center mb-20 pt-64 pb-64">
                <img class="storage-msg-icon" src="/assets/images/home_storage.svg" />
                <div class="mat-subtitle-1 fw-700 mt-12 mb-16 fs-20">{{'INSTANCE_DETAILS.NO_RELEASE_PACKAGE' | transloco}}</div>
              </div>
            </ng-template>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="section-label mat-headline-6">{{'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</span>
            </ng-template>
            <mat-divider class="neutral-2"></mat-divider>
            <div class="flex flex-row justify-between items-center mb-24 mt-16 w-100-percent">
              <div class="mat-body-1 fw-700 title m-0">
                <span class="mr-8 mat-headline-6 fw-700 fs-16">{{ 'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</span>
              </div>
              <div class="flex flex-row items-center">
                <button [matMenuTriggerFor]="menu" #filterTrigger class="flex justify-between items-center fw-500 white-bg mr-20">
                  <mat-icon svgIcon="filter_alt" class="mr-8 mb-2"></mat-icon>
                  <span>{{ 'INSTANCE_DETAILS.FILTERS' | transloco }}</span>
                </button>
                <mat-menu #menu="matMenu" class="justify-between items-center pl-24 pr-24 pt-16 pb-16">
                  <span class="mat-subtitle-2 fs-14">{{ 'INSTANCE_DETAILS.FILTER_BY_STATUS' | transloco }}</span>
                  <mat-divider class="neutral-2 mt-8 mb-16"></mat-divider>
                  <div class="flex flex-col overflow-class pr-10 filter-menu">
                    <div *ngFor="let option of filterOptions" class="flex flex-row items-center cursor-pointer w-100-percent p-6"
                      (click)="!isExternalClient ? rvtFilterOptionChange(option) : ''" >
                      <mat-icon *ngIf="selectedRvtFilter.value !== option.value" svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
                      <mat-icon *ngIf="selectedRvtFilter.value === option.value" svgIcon="radio_button_checked" class="radio-icon cursor-pointer">
                        </mat-icon>
                      <span class="mat-body-1 fw-500 ml-6 mr-auto mb-0 primary-fg">
                        {{option.label}}
                      </span>
                    </div>
                  </div>
                </mat-menu>
                <app-search-filter placeholder="SEARCH.SEARCH" (changed)="searchRvt($event)"></app-search-filter>
              </div>
            </div>
            <ng-container *ngIf="pageRvtStates?.length > 0 && rvtResultsLoaded; else resultNotAvailable">
              <div class="tbl tbl-configurations-state w-100-percent pb-12">
                <div class="tbl-header-row primary mb-8 user-select-none">
                  <div class="tbl-cell col-release-package-name pl-12">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.RELEASE_PACKAGE_NAME' | transloco }}</div>
                  <div class="tbl-cell col-version">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.VERSION' | transloco }}</div>
                  <div class="tbl-cell col-start-time cursor-pointer" (click)="doRvtSort('applicationStartTime')">
                    {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco }}
                    <ng-container [ngTemplateOutlet]="sortIcon"
                      [ngTemplateOutletContext]="{sort: sort, property: 'applicationStartTime'}"></ng-container>
                  </div>
                  <div class="tbl-cell col-end-time cursor-pointer" (click)="doRvtSort('applicationFinishTime')">
                    {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}
                    <ng-container [ngTemplateOutlet]="sortIcon"
                      [ngTemplateOutletContext]="{sort: sort, property: 'applicationFinishTime'}"></ng-container>
                  </div>
                  <div class="tbl-cell col-duration cursor-pointer" (click)="doRvtSort('duration')">
                    {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}
                    <ng-container [ngTemplateOutlet]="sortIcon"
                      [ngTemplateOutletContext]="{sort: sort, property: 'duration'}"></ng-container>
                  </div>
                  <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
                </div>
                <div class="tbl-body">
                  <div *ngFor="let configurationState of pageRvtStates" class="tbl-border mb-8">
                    <div class="tbl-body-row tbl-high-row">
                      <div class="tbl-cell col-release-package-name cursor-pointer pl-12" (click)="!isExternalClient ? configurationNameClick(configurationState): ''">
                        <span class="underline">{{ configurationsMap[configurationState.configurationId].manifest.name }}</span>
                      </div>
                      <div class="tbl-cell col-version">
                        {{ configurationsMap[configurationState.configurationId].manifest.version }}
                      </div>
                      <div class="tbl-cell col-start-time">
                        {{ configurationState.applicationStartTime ? (configurationState.applicationStartTime | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) : '-' }}
                      </div>
                      <div class="tbl-cell col-end-time">
                        {{ configurationState?.applicationFinishTime ? (configurationState?.applicationFinishTime | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) : '-' }}
                      </div>
                      <div class="tbl-cell col-duration">
                        {{ configurationState.applicationStartTime | duration : configurationState.applicationFinishTime : '-' }}
                      </div>
                      <div class="tbl-cell col-status">
                        <div class="status-tag" [ngClass]="[configurationState.status === ConfigurationApplicationStatus.SUCCESS ? 'success' : configurationState.status === ConfigurationApplicationStatus.VERIFIED ? 'verified' : 'fail']">
                          <ng-container [ngSwitch]="configurationState.status">
                            <span *ngSwitchCase="ConfigurationApplicationStatus.SUCCESS">{{ 'CONFIGURATIONS.VIEW_RESULTS.SUCCESS' | transloco }}</span>
                            <span *ngSwitchCase="ConfigurationApplicationStatus.VERIFIED">{{ 'CONFIGURATIONS.VIEW_RESULTS.VERIFIED' | transloco }}</span>
                            <span *ngSwitchDefault>{{ 'CONFIGURATIONS.VIEW_RESULTS.FAILED' | transloco }}</span>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="!rvtResultsLoaded">
              <div class="pt-8">
                <div class="pt-12 pb-12 pl-20 mb-8 header-loader">
                  <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                  <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                  <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                </div>
                <ng-container *ngFor="let item of [1,2,3]">
                  <div class="p-20 pt-24 mb-8 loader">
                    <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #resultNotAvailable>
              <div *ngIf="rvtResultsLoaded" class="flex flex-col items-center mb-20 pt-64 pb-64">
                <mat-icon svgIcon="inventory_2" class="no-release-color icon-lg mr-12"></mat-icon>
                <div class="mat-subtitle-1 fw-700 mt-12 mb-16 fs-20">{{'INSTANCE_DETAILS.NO_RESULT_AVAILABLE' | transloco}}</div>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </ng-container>
      <app-paginator #paginator [ngClass]="{'hide': (!isReleasePack || selectedTab !== 1)}"></app-paginator>
      <app-paginator #rvtPaginator [ngClass]="{'hide': (!isRvtPack || selectedRvtTab !== 1)}"></app-paginator>
      <ng-template #sortIcon let-sort="sort" let-property="property">
        <img *ngIf="!sort || sort.property !== property" class="icon-sm" src="/assets/icons/sort.svg">
        <img *ngIf="sort?.property === property" class="icon-sm" [src]="'/assets/icons/sort-' + sort.direction + '.svg'">
      </ng-template>
    </div>
  </div>
</div>